angular.module('cvsApp').service('authenticateGuestUserService',['networkService', 'xdrService', 'authenticateGuestUserModel', 'configManager', function (NS, XS, AGUM, CM) {
   	
	function authenticateGuestUserService (){	
		this.authenticateGuestUser = function(req, callBackSuccess){
			//get url 
			var url = CM.getGuestUrl('AUTH_GUEST_USER');
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
							header:{"Content-Type":"application/xml"},
							data:getRequestBody(req),
							onSuccess:callBackSuccess
						}
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, getRequestBody(req), xdrSuccess);

					function xdrSuccess (data) {
						AGUM.setResponse(data);
						callBackSuccess(AGUM.getResponse());
					}
				}
				else {
					var authPromise = NS.post(request);	
					authPromise.then(function(data, c, d){

						AGUM.setResponse(data.data);
						callBackSuccess(AGUM.getResponse());


						
					});	
				}		
			}
							
		}
		var tokenId;
		this.setTokenId = function (tid) {
			tokenId = tid;
		}

		this.getTokenId = function () {
			return tokenId;
		}

		var getRequestBody = function(req){
				var date = new Date();			
				var currentYear = date.getFullYear();
				var currentMonth =convertToTwoDigit(date.getMonth() + 1);
				var currentDay = convertToTwoDigit(date.getDate());
				
				var hour = convertToTwoDigit(date.getHours());
				var minute = convertToTwoDigit(date.getMinutes());
				var second = convertToTwoDigit(date.getSeconds());

				var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour 
					+ ':' + minute + ':' + second;
					
				var requestJson = {request:{
								tokenID:req.tokenId,
								tokenType:'Partial-Login',
								apiKey:cvsUtility.queryMap.apikey,
								timestamp:timeStamp,
								zipCode:req.zipCode,
								dateOfBirth: req.dob
							}}
				
				return cvsUtility.JSONToXml(requestJson);

				function convertToTwoDigit (number) {
					return (number < 10) ? '0' + number : number;
				}
			}			
	}
	
	return new authenticateGuestUserService();	
}]);
